export const ECGLead = {
  I: 'Lead I',
  II: 'Lead II',
  III: 'Lead III',
  V1: 'Lead V1',
  V2: 'Lead V2',
  V3: 'Lead V3',
  V4: 'Lead V4',
  V5: 'Lead V5',
  V6: 'Lead V6',
  aVR: 'Lead aVR',
  aVL: 'Lead aVL',
  aVF: 'Lead aVF',
} as const;
